<div class="mt-5 text-center">
  <p>Copyright © {{ currentYear }} Medinbox.</p>
</div>
